import styled, { keyframes } from 'styled-components' // eslint-disable-line no-unused-vars

const headerBgColor = `rgb(117, 204, 246)`
const footerBgColor = `rgb(117, 204, 246)`
const ApplayoutContent = `rgb(0, 144, 222)`
const btColor = `rgb(237, 0, 126)`
const bgColor = `white`
const localeActiveBorderColor = `rgb(237, 0, 126)`
const eventContentH1BgColor = `rgb(69,120,181)`
const eventContentDetailsBgColor = `rgb(240,240,240)`
// color 1st set
const simpleBgColor = `rgb(237, 0, 126)`
const fontColor = `white`
const recentlyBgColor = `rgb(32, 50, 139)`
// color 2nd set
const fontColor2 = `black`
const simpleBgColor2 = `rgb(237, 0, 126)`

export const AppWrapper = styled.div`
  font-family: "Kanit", sans-serif;
  .modlink {
    color: beige;
    text-decoration: underline;
  }
  .modlink2 {
    color: #1890ff;
    text-decoration: underline;
  }
  .eventBottomDetail {
    margin-top: 15px;
    li {
      color: ${fontColor2};
    }
  }
  .localeSwitcher .locale.active { 
    border-bottom: 2px solid ${localeActiveBorderColor}; 
  } 
  .historyList {
    padding: 12px;
    margin-bottom: 18px;
    background-color: ${bgColor};
    color: ${fontColor2};
  }
  .registrationCode {
    color: ${fontColor2};
    font-size: 16px;
    margin-right: 8px;
  }
  .eventTitle a {
    color: ${simpleBgColor2}; 
  }
  .normal_btn.orangeborder_btn {
    border: 1px solid ${simpleBgColor2};
    color: ${simpleBgColor2};
    background-color: white;
    width: 100%;
  }
  .eventContent h1 {
    margin-bottom: 8px;
    margin-top: 26px;
    padding: 0 20px;
    display: inline-block;
    color: white;
    font-size: 20px;
    background: ${simpleBgColor2};
    text-align: center;
    width: 100%;
    text-align: left;
  }
  .short_description {
    min-height: 60px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    background-color: ${simpleBgColor2};
  }
  .title_line > * {
    background-color: white;
    padding: 0 20px;
    margin-left: 40px;
    color: ${simpleBgColor2};
    display: inline-block;
  }
  .countdown_box .digi {
    border: 1px solid ${simpleBgColor2};
    display: inline-block;
    color: dimgray;
    background-color: #ffffff;
    width: 35px;
    line-height: 50px;
    font-size: 22px;
    margin: 2px;
  }
  .countdown_title {
    color: ${simpleBgColor2};
    margin-top: 10px;
  }
  .eventBottomDetailTitle {
    color: ${simpleBgColor2};
    font-size: 14px;
    padding-right: 15px;
  }
  .payButtom {
    text-align: center;
    background-color: ${simpleBgColor2};
    color: #ffffff;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  .choosePayment:hover {
    border: 1px solid ${simpleBgColor2};
    cursor: pointer;
  }
  .lineLoginTitle {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 14px;
    font-size: 16px;
    border-bottom: 1px solid ${simpleBgColor2};
    text-align: center;
  }
  div.simpleBgColor {
    background: ${simpleBgColor};
    color: white;
  }
  div.ant-layout-header {
    min-height: 85px;
    transition: 0.5s all ease;
    width: 100%;
    padding: 0;
    background-color: ${headerBgColor}
  }
  div.ant-layout-content {
    background-color: ${ApplayoutContent};
    min-height: 100vh;
  }
  .adjustBtn {
    height: 30px;
    background-color: ${localeActiveBorderColor};
    color: ${fontColor};
    min-width: 125px;
    text-align: center;
    display: inline-block;
    line-height: 30px;
    transition: 0.5s all ease;
    cursor: pointer;
  }
  div.wrap-recently {
    background-color: ${recentlyBgColor};
  }
  .shape {
    min-width: 150px;
    padding: 0 20px;
    display: inline-block;
    height: 30px;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    background: rgb(62, 111, 178);
    text-align: center;
  }
  .localeSwitcher .locale.active {
    border-color: ${localeActiveBorderColor};
  }
  a.login_btn {
    height: 30px;
    background-color: ${localeActiveBorderColor};
    color: ${fontColor};
    min-width: 125px;
    text-align: center;
    display: inline-block;
    line-height: 30px;
    transition: 0.5s all ease;
    cursor: pointer;
  }
  div.login_btn.login.menuItem {
    height: 30px;
    background-color: ${localeActiveBorderColor};
    color: ${fontColor};
    min-width: 125px;
    text-align: center;
    display: inline-block;
    line-height: 30px;
    transition: 0.5s all ease;
    cursor: pointer;
  }
  .menu_icon {
    margin-right: 40px;
    margin-top: 30px;
    cursor: pointer;
    color: ${btColor};
    position: absolute;
    right: 0;
    top: 0;
  }
  .loginButtonHeader {
    text-align: center;
    font-size: 14px;
    width: 100%;
    color: ${fontColor};
    background-color: ${btColor};
    padding: 5px;
  }
  .loginButtonDropDown {
    text-align: center;
    width: 100%;
    margin: 0 auto;
    margin-top: 6px;
    font-weight: 900;
  }

  .eventCardRegisterBtn {
    background-color: ${btColor};
    padding: 10px 10px 10px 10px;
    border-radius: 15px;
    cursor: pointer;
    color: ${fontColor};
    margin: 5px;
  }
  .eventCardDetail {
    color: ${fontColor};
    display: flex;
    text-align: left;
  }

  div.content.content-upcoming {
    text-align: center;

    div.eventCardBox {
      display: inline-block;
      margin: 10px;

      div.eventCard {
        text-align: center;
        width: 360px;
        height: 291px;
        
        .eventCardImg {
          width: 360px;
          height: 200px;
          object-position: center;
          object-fit: cover;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
        }
        .eventCardDetail {
          width: 360px;
          background-color: ${bgColor};
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          border-top: 1px solid #8080804a;
          .eventCardDateBox {
            position: relative;
            /* background-image: url('/borderBox.png') !important; */
            background-repeat: no-repeat;
            background-size: 90px;
            width: 90px;
            height: 90px;
            display: table;
          }

          .eventCardDateBoxContent {
            vertical-align: middle;
            display: table-cell;
            text-align: center;
            .eventCardDateBoxText {
              color: ${fontColor2};
            }
            .eventCardDateBoxTextMonth {
              color: ${btColor};
            }
          }

          .infoRigtSide {
            display: table;
            width: 205px;
            height: 90px;
            padding: 5px;
            .eventCardEventTitle {
              vertical-align: middle;
              display: table-cell;
              font-size: 18px;
              color: ${fontColor2};
            }
          }

          .eventCardRegisterBox {
            display: table;
            height: 90px;
            .btnWrapper{
              vertical-align: middle;
              display: table-cell;
            }
          }
        }
      }   
    }

    @media screen and (min-width: 600px) { 
      div.eventCardBox {
        display: flex;
        text-align: center;
        div.eventCard {
          width: 990px;
          text-align: center;
          height: auto;

          img.eventCardImg {
            width: 100%;
            height: auto;
          }
          div.eventCardDetail {
            width: 100%;
            div.eventCardDateBox {
              width: 136px;
              .eventCardDateBoxText {
                font-size: 33px;
              }
              .eventCardDateBoxTextMonth {
                font-size: 19px;
              }
            }
            div.infoRigtSide {
              width: 100%;
              .eventCardEventTitle {
                font-size: 24px;
                text-align: center;
              }
            }
            .eventCardRegisterBtn {
              margin: 16px;
              font-size: 24px;
            }
          }
        }
      }
    }
    @media screen and (min-width: 600px) and (-webkit-min-device-pixel-ratio:0) {
      div.infoRigtSide {
        width: calc(100% - 262px) !important;
      }
    }
    @media screen and (max-width : 375px) {
      div.eventCardBox {
        zoom: 86%;
        margin:2px;
      }
    }
    @media screen and (max-width : 720px) {
      div.eventCardBox {
        margin-right: 0;
      }
    }
  }

  div.content.content-recently {
    text-align: center;

    div.eventCardBox {
      display: inline-block;
      margin: 10px;
      .eventCardFinish {
        text-align: center;
        .eventCardImgFinish {
          width: 252px;
          height: 160px;
          object-position: center;
          object-fit: cover;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          background-color: ${bgColor};
          display: inline-block
        }
        .eventCardDetail {
          background-color: ${bgColor};
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          border-top: 1px solid #8080804a;
          width: 252px;
          .infoRigtSide {
            display: table;
            width: 179px;
            height: 60px;
            padding: 5px;
            .eventCardEventTitle {
              vertical-align: middle;
              display: table-cell;
              font-size: 18px;
              color: ${fontColor2};
            }
          }

          .eventCardRegisterBox {
            display: table;
            height: 90px;
            .btnWrapper{
              vertical-align: middle;
              display: table-cell;
            }
          }
        }
      }
    }
  }
  
  .ant-layout-footer {
      background-color: ${footerBgColor};
  }
`
export const HeaderWrapper = styled.div`
  div.header {
    div.headerBg {
      .logo {
        height: 65px;
        margin: 10px 0 0 55px;
      }
    }
  }
`

export const Container = styled.div`
  
`
export const EventPageContent = styled.div`
  display: flex;
  justify-content: center;
  div.eventPage {
    background-color: ${bgColor};
    color: ${fontColor2};

    width: 990px;
    div.entryFeeBnt {
      height: 30px;
      background-color: ${btColor};
      color: ${fontColor};
      min-width: 125px;
      text-align: center;
      display: inline-block;
      line-height: 30px;
      cursor: pointer;
      font-family: 'Kanit';
      i {
        padding-left: 5px;
      }
    }
    .img-event {
      img {
        width: 100%;
        height: auto;
      }
    }

    .dateBoxText {
      color: ${fontColor2};
      font-size: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
    table.entryFee {
      margin-top: 0;
      color: ${fontColor};
      font-family: 'Kanit';
      td {
        color: ${fontColor2};
        font-family: 'Kanit';
      }
      tr.entryFreeNameAndPrice {
        border-bottom: solid 3px #3c6dac8c;
      }
    }
    table {
      margin-bottom: 20px;
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      background-color: transparent;
    }

    .eventContent {
      section h1 {
        background-color: ${eventContentH1BgColor};
      }
      .details {
        padding: 15px;
        background: ${eventContentDetailsBgColor};
      }
    }


    .side_bar {
      padding: 10px 10px 20px 10px;
      background: rgb(240, 240, 240);
      text-align: center;
      margin-left: 10px;
      margin-right: 10px;
      margin-top: 25px;

      .no_pd {
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-right: 0px !important;
        margin-left: 0px !important;
        .fee_title_line {
          width: 100%;
          margin: 30px auto 10px auto;
          height: 14px;
          .title {
            font-size: 20px;
            color: ${fontColor2};
          }
        }
      }

      table thead {
        background-color: gray;
        text-align: left;
      }
      table td {
        height: 30px;
        padding: 15px 8px 10px;
        min-height: 30px;
        text-align: left;
        font-size: 14px;
      }

      table td.fee {
        text-align: right;
        width: 80px;
      }

      table thead td {
        color: ${fontColor};
        text-align: left;
      }

      .detailTitle {
        text-align: left;
        font-size: 20px;
        color: ${btColor};
        padding-left: 20px
      }
      .detailInfo {
        text-align: left;
        font-size: 16px;
        color: ${btColor};
        padding-left: 20px;
      }
    }
  }
`

export const ProfileBox = styled.div`
  display: flex;
  justify-content: center;
  .inProfileBox {
    width: 100%;
    background-color: ${bgColor};
    padding: 20px;
    .profileIcon {
      padding: 0 20px;
      margin-bottom: 20px;
      padding-top: 25px;
    }
    .profileName {
      font-size: 18px;
      color: ${fontColor2};
    }
    .shapeTopic {
      min-width: 150px;
      padding: 0 20px;
      display: inline-block;
      height: 30px;
      background: rgb(71, 122, 187);
      text-align: center;
    }
    .profileInfo {
      margin-left: 20px;
      .profileNameBox {
        text-align: center;
        border-bottom: 1px solid gainsboro;
        padding-bottom: 25px;
        margin-bottom: 20px;
      }
      .profileInfoTitle {
        color: ${btColor};
        font-size: 16px;
        margin-left: 10px;
      }
      .profileInfoData {
        font-size: 20px;
        color: ${fontColor2};
      }
      .profileInfo {
        margin-left: 20px;
      }
      .profileInfoDataBox {
        margin-left: 20px;
      }
    }
  }
`

export const EditProfilePageContent = styled.div`
  padding-bottom: 16px;
  background-color: ${bgColor};
  .profileInfo{
    .profileInfoTitle {
      color: ${btColor};
      font-size: 16px;
      margin-left: 10px;
    }
    
  }
  
  input {
    width: 269px;
  }
  .ant-form-item-control-wrapper {
    width: 269px;
  }
  
  .editProfileBox {
    display: flex;
    justify-content: center;
    margin: 20px;
    .editProfileButton {
      text-align: center;
      background-color: ${btColor};
      width: 60px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 15px;
      padding-right: 15px;
      color: ${fontColor};
    }
    .editProfileButton:hover {
      cursor: pointer;
    }
  }
`

export const DashBoardBox = styled.div`
  margin-top: 20px;
  padding: 10px;
  .profile {
    background-color: ${bgColor};
    padding: 20px;
    margin-right: 20px;
    color: ${fontColor2};
  }
  .registerName {
    margin: 15px 0;
    border-bottom: 1px solid gainsboro;
    width: 90%;
    padding-bottom: 20px;
    display: inline-block;
    font-size: 16px;
    color: ${fontColor2};
  }

`



// WEBPACK FOOTER //
// ./src/styles/index.js